import React from 'react'
import styled from '@emotion/styled'
import { Button } from 'antd'
import { elements, tags, colors } from 'style/theme'

const StyledScanFilterTag = styled.div(({type}) => ({
	position: 'relative',
	cursor: 'pointer',
	padding: 10,
	margin: '5px 10px 5px 0',
	borderRadius: elements.brandBorderRadius,
	textAlign: 'center',
	fontWeight: 700,
	...tags[type]
}))

const StyledClose = styled(Button)(({filtertype}) => ({
	position: 'absolute',
	top: '-6px',
	right: '-6px',
	color: colors.brandWhite,
	background: tags[filtertype].color,
	border: 'none',
	width: 18,
	height: 18,
	minWidth: 18,
	fontSize: 10,
	'&:hover': {
		color: colors.brandWhite,
		background: tags[filtertype].hover
	}
}))

const ScanFilterTag = ({ attribute, onClose, onClick }) => {
	let { type, condition, value } = attribute
	let filterType = condition.includes('not') ? 'exclusive' : 'inclusive'
	let formattedValue = condition.includes('in') ? `(${value})` : value
	let filterText = `${type} ${condition.toUpperCase()} ${formattedValue}`
	return (
		<StyledScanFilterTag type={filterType} onClick={onClick ? () => onClick(attribute) : null}>
			<StyledClose filtertype={filterType} shape="circle" icon="close" onClick={onClose ? () => onClose(attribute) : null} />
			<span>{filterText}</span>
		</StyledScanFilterTag>
	)
}

export default ScanFilterTag
